module.exports = __webpack_public_path__ + "static/media/audio-ads.9cbfbeaf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/audio-ads.svg
// module id = 110
// module chunks = 1